import UserReviewList from 'components/OfferPage/NavigableOfferContent/UserReviewList'
import React, { memo } from 'react'
import TourV2OperatorReview from './TourV2OperatorReview'

interface Props {
  tour: Tours.V2Offer;
}

function TourV2ReviewsList(props: Props) {
  const { tour } = props

  if (tour.reviewsSource === 'le_tour_operator') {
    return <TourV2OperatorReview tour={tour} />
  }

  return <UserReviewList tour={tour} />
}

export default memo(TourV2ReviewsList)
